import React, { useState, useEffect } from "react";
import { getAllMPStainlessSteelTempTables } from '../../services/tables/MPStainlessSteelTempTableService';
import MPStainlessSteelSheetTable from "../../components/tecnical-sheets/MPStainlessSteelTempTable";
import { Container } from "@mui/material";
import { Backdrop, CircularProgress } from "@mui/material";
import Notify from "../../components/global/Notify";

export default function MPStainlessSteelTempTablePage() {
  const [searchString, setSearchString] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await getAllMPStainlessSteelTempTables(0, 20, searchString);
        setRows(res.content);
      } catch (error) {
        if (error?.silent) {
          return;
        }
        notify(error.message, false);
      } finally {
        setLoading(false);
      }
    })();
  }, [searchString]);

  const notify = (message, isSucessMessage) => {
    if (isSucessMessage) {
      Notify.success(message);
    } else {
      Notify.error(message);
    }
  };

  const onSearchChange = (search) => setSearchString(search);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        width: "98%",
        marginRight: "2%",
        position: "relative",
        boxShadow: 4,
      }}
    >
      <MPStainlessSteelSheetTable
        rows={rows}
        onSearchChange={onSearchChange}
      />
      <Backdrop
        open={loading}
        sx={{
          position: "absolute",
          color: "#04642c",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
    </Container>

  );
}